import React, { useEffect, useRef } from "react";

import QRCode from "qrcode";

export const QrCode = ({ data }) => {
  const qrCodeRef = useRef();

  const fillQrCode = () => {
    QRCode.toCanvas(qrCodeRef.current, typeof data === 'string' ? data : JSON.stringify(data));
  };

  useEffect(() => {
    fillQrCode();
  }, []);

  return <canvas ref={qrCodeRef} />;
};
